import React, { useState, useEffect } from "react";
import OrdersAndTransactions from "./OrdersAndTransactions";
import Dashboard from "./Dashboard";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { TabsGenerator } from "../../../../Common";
import Analytics from "./Analytics";
import TransactionsDetails from "./TransactionsDetails";
import OrdersSummary from "./OrdersSummary";

const tabs = [
  {
    label: "Dashboard",
    value: "dashboard",
    component: <Dashboard />,
  },
  {
    label: "Orders and Transactions",
    value: "orders_and_transactions",
    component: <OrdersAndTransactions />,
  },
  {
    label: "Analytics",
    value: "analytics",
    component: <Analytics />,
  },
  {
    label: "Orders Summary",
    value: "orders_summary",
    component: <OrdersSummary />,
  },
  {
    label: "Transactions Summary",
    value: "tranactions_summary",
    component: <TransactionsDetails />,
  },
];

const SU_Tabs = [
  {
    label: "Orders and Transactions",
    value: "orders_and_transactions",
    component: <OrdersAndTransactions />,
  },
];

const FinancialManagement = () => {
  const [activeTab, setActiveTab] = useState(null);
  const current_user = useSelector((state) => state.userReducer.current_user);
  const location = useLocation();

  useEffect(() => {
    const queryParam = new URLSearchParams(location.search);
    const tabName = queryParam.get("tab");

    if (tabName) {
      setActiveTab(tabName);
    } else if (current_user.type === "SU") {
      setActiveTab("orders_and_transactions");
    } else {
      setActiveTab("dashboard");
    }
  }, [location, current_user.type]);

  return (
    <>
      {activeTab && (
        <TabsGenerator
          tabsList={current_user.type === "SU" ? SU_Tabs : tabs}
          activeTabs={activeTab}
        />
      )}
    </>
  );
};

export default FinancialManagement;
